export const wineFilterData = [
  {
    key: 'customData.product.region',
    title: 'Region',
    type: 'checkbox',
    color: '#b25661',
    options: [
      { displayLabel: 'Champagne', key: 'Champagne' },
      { displayLabel: 'California', key: 'California' },
      { displayLabel: 'Sonoma County, CA', key: 'Sonoma County, California' },
      { displayLabel: 'Napa Valley, CA', key: 'Napa Valley, California' },
      { displayLabel: 'Willamette Valley, OR', key: 'Willamette Valley, Oregon' },
      { displayLabel: 'Northern Italy', key: 'Northern Italy' },
      { displayLabel: 'Piedmonte', key: 'Piedmonte' },
      { displayLabel: 'Tuscany', key: 'Tuscany' },
      { displayLabel: 'Provence', key: 'Provence' },
      { displayLabel: 'Oregon', key: 'Oregon' },
      { displayLabel: 'Rioja', key: 'Rioja' },
      { displayLabel: 'Burgundy', key: 'Burgundy' },
      { displayLabel: 'Rhone Valley', key: 'Rhone Valley' },
      { displayLabel: 'Loire', key: 'Loire' },
      { displayLabel: 'Patagonia', key: 'Patagonia' },
      { displayLabel: 'Barolo', key: 'Barolo' },
      { displayLabel: 'Abruzzo', key: 'Abruzzo' },
      { displayLabel: 'Alto Adige', key: 'Alto Adige' },
      { displayLabel: 'Arroyo Seco, CA', key: 'Arroyo Seco, California' },
      { displayLabel: 'Ballard Canyon, CA', key: 'Ballard Canyon, California' },
      { displayLabel: 'Beaujolais', key: 'Beaujolais' },
      { displayLabel: 'St Emilion, Bordeaux', key: 'St Emilion, Bordeaux' },
      { displayLabel: 'Pessac-Leognan, Bordeaux', key: 'Pessac-Leognan, Bordeaux' },
      { displayLabel: 'Cote de Bordeaux', key: 'Cote de Bordeaux' },
      { displayLabel: 'Chinon, Loire', key: 'Chinon, Loire' },
      { displayLabel: 'Menetou-Salon, Upper Loire', key: 'Menetou-Salon, Upper Loire' },
      { displayLabel: 'Chiles Canyon, CA', key: 'Chiles Canyon, Napa Valley, California' },
      { displayLabel: 'Oakville, CA', key: 'Oakville, Napa Valley' },
      { displayLabel: 'Rutherford Valley, CA', key: 'Rutherford Valley, California' },
    ],
  },
  {
    key: 'customData.product.varietal',
    title: 'Varietal',
    type: 'checkbox',
    options: [
      { key: 'Pinot Noir', displayLabel: 'Pinot Noir' },
      { key: 'Chardonnay', displayLabel: 'Chardonnay' },
      { key: 'Sauvignon Blanc', displayLabel: 'Sauvignon Blanc' },
      { key: 'Cabernet Sauvignon', displayLabel: 'Cabernet Sauvignon' },
      { key: 'Pinot Grigio', displayLabel: 'Pinot Grigio' },
      { key: 'Tempranillo', displayLabel: 'Tempranillo' },
      { key: 'Nebbiolo', displayLabel: 'Nebbiolo' },
      { key: 'Sangiovese', displayLabel: 'Sangiovese' },
      { key: 'Zinfandel', displayLabel: 'Zinfandel' },
      { key: 'Syrah', displayLabel: 'Syrah' },
      { key: 'Merlot', displayLabel: 'Merlot' },
      { key: 'Cab Franc', displayLabel: 'Cabernet Franc' },
      { key: 'Primitivo', displayLabel: 'Primitivo' },
      { key: 'Malbec', displayLabel: 'Malbec' },
    ],
  },
  {
    key: 'price',
    title: 'Price',
    type: 'range',
    min: 0,
    max: 300,
    sliderBgColor: '#b25661',
    color: '#000',
    currency: '$',
  },
  {
    key: 'customData.product.color',
    title: 'Wine Color',
    type: 'checkbox',
    options: [
      { displayLabel: 'Red', key: 'Red' },
      { displayLabel: 'White', key: 'White' },
      { displayLabel: 'Rosé', key: 'Rose' },
      { displayLabel: 'Rosé (Accented)', key: 'Rosé' },
      { displayLabel: 'Tawny', key: 'Tawny' },
      { displayLabel: 'Wine', key: 'Wine' },
    ],
  },
];

export const beerFilterData = [
  {
    key: 'customData.product.style',
    title: 'TYPE',
    type: 'checkbox',
    options: [
      { displayLabel: 'Lager', key: 'Lager' },
      { displayLabel: 'IPA', key: 'IPA' },
      { displayLabel: 'Stout', key: 'Draught Stout' },
      { displayLabel: 'Pale Ale', key: 'Pale Ale' },
    ],
  },
  {
    key: 'customData.product.style',
    title: 'STYLE',
    type: 'checkbox',
    options: [
      { displayLabel: 'Pilsner', key: 'Pilsner Style Mexican Lager' },
      { displayLabel: 'Japanese Rice Lager', key: 'Japanese style rice lager' },
      { displayLabel: 'Blonde Lager', key: 'Blonda Premium Lager' },
    ],
  },
  {
    key: 'customData.product.country',
    title: 'COUNTRY / ORIGIN',
    type: 'checkbox',
    options: [
      { displayLabel: 'Germany', key: 'Germany' },
      { displayLabel: 'Belgium', key: 'Belgium' },
      { displayLabel: 'USA', key: 'USA' },
      { displayLabel: 'Ireland', key: 'Ireland' },
      { displayLabel: 'Czech Republic', key: 'Czech Republic' },
    ],
  },
  {
    key: 'customData.product.size',
    title: 'PACK SIZE',
    type: 'checkbox',
    options: [
      { displayLabel: '12 FL OZ', key: '12 FL OZ' },
      { displayLabel: '11.2 FL OZ', key: '11.2 FL OZ' },
      { displayLabel: '1 Pint', key: '1 Pint' },
      { displayLabel: '8-Pack 14.9 FL OZ', key: '8-Pack 14.9 FL OZ' },
      { displayLabel: '6-Pack 1 FL OZ', key: '6-Pack 1 FL OZ' },
    ],
  },
  {
    key: 'price',
    title: 'PRICE',
    type: 'range',
    min: 0,
    max: 50,
    sliderBgColor: '#b25661',
    color: '#000',
    currency: '$',
  },
];

export const spiritsFilterData = [
  {
    key: 'customData.product.type',
    title: 'TYPE',
    type: 'checkbox',
    options: [
      { displayLabel: 'Bourbon', key: 'Bourbon' },
      { displayLabel: 'Bourbon Whiskey', key: 'Bourbon Whiskey' },
      { displayLabel: 'Rye Whiskey', key: 'Rye Whiskey' },
      { displayLabel: 'Corn Whiskey', key: 'Corn Whiskey' },
      { displayLabel: 'Vodka', key: 'Vodka' },
      { displayLabel: 'Gin', key: 'Gin' },
      { displayLabel: 'Rum', key: 'Rum' },
      { displayLabel: 'White Rum', key: 'White Rum' },
      { displayLabel: 'Spiced Rum', key: 'Spiced Rum' },
      { displayLabel: 'Scotch', key: 'Scotch' },
      { displayLabel: 'Single Malt Scotch', key: 'Single Malt Scotch Whiskey' },
      { displayLabel: 'Tequila (Accented)', key: 'Tequila' },
      { displayLabel: 'Tequila', key: 'Tequilla' },
      { displayLabel: 'Tequila Blanco', key: 'Tequilla Blanco' },
      { displayLabel: 'Tequila Reposado', key: 'Tequilla Reposado' },
      { displayLabel: 'Tequila Anejo', key: 'Tequilla Anejo' },
      { displayLabel: 'Limoncello', key: 'Limoncello' },
      { displayLabel: 'Liqueur', key: 'Liqueur' },
    ],
  },
  {
    key: 'customData.product.sub-type',
    title: 'SUB-TYPE',
    type: 'checkbox',
    options: [
      { displayLabel: 'Scotch', key: 'Scotch' },
      { displayLabel: 'Bourbon', key: 'Bourbon' },
      { displayLabel: 'Single Malt', key: 'Single Malt' },
      { displayLabel: 'Blended', key: 'Blended' },
    ],
  },
  {
    key: 'customData.product.region',
    title: 'REGION / COUNTRY',
    type: 'checkbox',
    options: [
      { displayLabel: 'Scotland', key: 'Scotland' },
      { displayLabel: 'USA', key: 'USA' },
      { displayLabel: 'Japan', key: 'Japan' },
      { displayLabel: 'India', key: 'India' },
      { displayLabel: 'Kentucky', key: 'Kentucky' },
      { displayLabel: 'Texas', key: 'Texas' },
      { displayLabel: 'Caribbean', key: 'Carribean' },
      { displayLabel: 'Virgin Islands', key: 'Virgin Islands' },
      { displayLabel: 'California', key: 'California' },
      { displayLabel: 'New York', key: 'New York' },
      { displayLabel: 'London', key: 'London' },
      { displayLabel: 'Las Vegas', key: 'Las Vegas, Nevada' },
    ],
  },
  {
    key: 'customData.product.abv',
    title: 'ABV (%)',
    type: 'range',
    min: 20,
    max: 60,
    sliderBgColor: '#b25661',
    color: '#000',
  },
  {
    key: 'price',
    title: 'PRICE',
    type: 'range',
    min: 0,
    max: 200,
    sliderBgColor: '#b25661',
    color: '#000',
    currency: '$',
  },
];

export const nonAlcoholicFilterData = [
  {
    key: 'customData.product.type',
    title: 'TYPE',
    type: 'checkbox',
    options: [
      { displayLabel: 'Non-Alc Negroni', key: 'Negroni Non Alcoholic' },
      { displayLabel: 'Non-Alc Gin', key: 'Gin Non-Alcoholic' },
      { displayLabel: 'Non-Alc Beer', key: 'Beer' },
      { displayLabel: 'Bloody Mary Mix', key: 'Bloody Mary Mix' },
      { displayLabel: 'Sparkling Blood Orange', key: 'SparklingBlood Orange' },
      { displayLabel: 'Club Soda', key: 'Club Soda' },
      { displayLabel: 'Tonic Water', key: 'Tonic Water' },
      { displayLabel: 'Lime Juice', key: 'Lime Juice' },
    ],
  },
  {
    key: 'customData.product.volume',
    title: 'VOLUME',
    type: 'checkbox',
    options: [
      { displayLabel: '12 FL OZ', key: '12 FL OZ' },
      { displayLabel: '200ml', key: '200ml' },
      { displayLabel: '250ml', key: '250 ml' },
      { displayLabel: '744 ML', key: '744 ML' },
      { displayLabel: '946 ML', key: '946 ML' },
    ],
  },
  {
    key: 'price',
    title: 'PRICE',
    type: 'range',
    min: 0,
    max: 40,
    sliderBgColor: '#b25661',
    color: '#000',
    currency: '$',
  },
];

export const gourmetFilterData = [
  {
    key: 'customData.product.gourmetCategory',
    title: 'CATEGORY',
    type: 'checkbox',
    options: [
      { displayLabel: 'Cheese', key: 'Cheese' },
      { displayLabel: 'Snacks', key: 'Snacks' },
      { displayLabel: 'Chocolates', key: 'Chocolates' },
      { displayLabel: 'Ready-to-eat', key: 'Ready-to-eat' },
    ],
  },
  {
    key: 'customData.product.cuisine',
    title: 'CUISINE',
    type: 'checkbox',
    options: [
      { displayLabel: 'Italian', key: 'Italian' },
      { displayLabel: 'French', key: 'French' },
      { displayLabel: 'Indian', key: 'Indian' },
    ],
  },
  {
    key: 'customData.product.dietary',
    title: 'DIETARY',
    type: 'checkbox',
    options: [
      { displayLabel: 'Veg', key: 'Veg' },
      { displayLabel: 'Non-veg', key: 'Non-veg' },
      { displayLabel: 'Vegan', key: 'Vegan' },
      { displayLabel: 'Gluten-free', key: 'Gluten-free' },
    ],
  },
  {
    key: 'customData.product.shelfLife',
    title: 'SHELF LIFE',
    type: 'checkbox',
    options: [
      { displayLabel: '< 1 month', key: '< 1 month' },
      { displayLabel: '1-6 months', key: '1-6 months' },
      { displayLabel: '6+ months', key: '6+ months' },
    ],
  },
  {
    key: 'price',
    title: 'PRICE',
    type: 'range',
    min: 0,
    max: 80,
    sliderBgColor: '#b25661',
    color: '#000',
    currency: '$',
  },
];

export const glasswareFilterData = [
  {
    key: 'customData.product.glasswareType',
    title: 'TYPE',
    type: 'checkbox',
    options: [
      { displayLabel: 'Wine Glass', key: 'Wine Glass' },
      { displayLabel: 'Beer Mug', key: 'Beer Mug' },
      { displayLabel: 'Whiskey Glass', key: 'Whiskey Glass' },
      { displayLabel: 'Champagne Flute', key: 'Champagne Flute' },
    ],
  },
  {
    key: 'customData.product.material',
    title: 'MATERIAL',
    type: 'checkbox',
    options: [
      { displayLabel: 'Crystal', key: 'Crystal' },
      { displayLabel: 'Glass', key: 'Glass' },
    ],
  },
  {
    key: 'customData.product.setSize',
    title: 'SET SIZE',
    type: 'checkbox',
    options: [
      { displayLabel: 'Single', key: 'Single' },
      { displayLabel: 'Set of 2', key: 'Set of 2' },
      { displayLabel: 'Set of 6', key: 'Set of 6' },
    ],
  },
  {
    key: 'customData.product.capacity',
    title: 'CAPACITY (ML)',
    type: 'range',
    min: 100,
    max: 700,
    sliderBgColor: '#b25661',
    color: '#000',
  },
  {
    key: 'price',
    title: 'PRICE',
    type: 'range',
    min: 0,
    max: 150,
    sliderBgColor: '#b25661',
    color: '#000',
    currency: '$',
  },
];

export const accessoriesFilterData = [
  {
    key: 'customData.product.accessoryType',
    title: 'TYPE',
    type: 'checkbox',
    options: [
      { displayLabel: 'Corkscrew', key: 'Corkscrew' },
      { displayLabel: 'Bottle Opener', key: 'Bottle Opener' },
      { displayLabel: 'Decanter', key: 'Decanter' },
      { displayLabel: 'Aerator', key: 'Aerator' },
      { displayLabel: 'Ice Bucket', key: 'Ice Bucket' },
    ],
  },
  {
    key: 'customData.product.usage',
    title: 'USAGE',
    type: 'checkbox',
    options: [
      { displayLabel: 'Wine', key: 'Wine' },
      { displayLabel: 'Beer', key: 'Beer' },
      { displayLabel: 'Spirits', key: 'Spirits' },
    ],
  },
  {
    key: 'customData.product.material',
    title: 'MATERIAL',
    type: 'checkbox',
    options: [
      { displayLabel: 'Steel', key: 'Steel' },
      { displayLabel: 'Wood', key: 'Wood' },
      { displayLabel: 'Glass', key: 'Glass' },
    ],
  },
  {
    key: 'price',
    title: 'PRICE',
    type: 'range',
    min: 0,
    max: 120,
    sliderBgColor: '#b25661',
    color: '#000',
    currency: '$',
  },
];


